webpackJsonp([17],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2GvU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.61d29bb.jpg";

/***/ }),

/***/ "7mNm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HJk8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HO3I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"topbar"},[_c('nav',{staticClass:"navbar top-navbar navbar-expand-md navbar-light"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"navbar-collapse"},[_c('ul',{staticClass:"navbar-nav mr-auto mt-md-0"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link sidebartoggler hidden-sm-down text-muted waves-effect waves-dark",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.sideBarToggler}},[_c('i',{staticClass:"ti-menu"})])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link sidebartoggler hidden-sm-down text-muted waves-effect waves-dark",attrs:{"href":"javascript:void(0)"}},[_vm._v(_vm._s(_vm.locationName))])])]),_vm._v(" "),_c('ul',{staticClass:"navbar-nav my-lg-0"},[(_vm.isConnected)?_c('li',{staticClass:"nav-item"},[_c('div',{staticClass:"nav-link",staticStyle:{"color":"white","font-size":"12px"}},[_vm._v("Server Online")])]):_vm._e(),_vm._v(" "),(!_vm.isConnected)?_c('li',{staticClass:"nav-item"},[_c('div',{staticClass:"nav-link",staticStyle:{"color":"white","font-size":"12px"}},[_vm._v("Server Offline")])]):_vm._e(),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('li',{staticClass:"nav-item dropdown"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right scale-up"},[_c('ul',{staticClass:"dropdown-user"},[_c('li',[_c('div',{staticClass:"dw-user-box"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"u-text"},[_c('h4',[_vm._v(_vm._s(_vm.userName))]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm._f("limitValue")(_vm.email)))]),_vm._v(" "),_c('a',{staticClass:"btn btn-rounded btn-danger btn-sm",attrs:{"href":"#"},on:{"click":_vm.sendTest}},[_vm._v("View Profile")])])])]),_vm._v(" "),_c('li',{staticClass:"divider",attrs:{"role":"separator"}}),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('li',{staticClass:"divider",attrs:{"role":"separator"}}),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.logout()}}},[_vm._m(6)])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-header"},[_c('a',{staticClass:"navbar-brand",attrs:{"href":"/"}},[_c('b',[_c('img',{staticClass:"light-logo",attrs:{"src":__webpack_require__("POok"),"width":"40","alt":"homepage"}})]),_vm._v(" "),_c('span',[_c('img',{staticClass:"light-logo",attrs:{"src":__webpack_require__("fXYR"),"alt":"homepage"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item dropdown hide"},[_c('a',{staticClass:"nav-link dropdown-toggle text-muted text-muted waves-effect waves-dark",attrs:{"href":"","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('i',{staticClass:"mdi mdi-message"}),_vm._v(" "),_c('div',{staticClass:"notify"},[_c('span',{staticClass:"heartbit"}),_vm._v(" "),_c('span',{staticClass:"point"})])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right mailbox scale-up"},[_c('ul',[_c('li',[_c('div',{staticClass:"drop-title"},[_vm._v("Notifications")])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"message-center"},[_c('a',{attrs:{"href":"#"}},[_c('div',{staticClass:"btn btn-danger btn-circle"},[_c('i',{staticClass:"fa fa-link"})]),_vm._v(" "),_c('div',{staticClass:"mail-contnet"},[_c('h5',[_vm._v("Luanch Admin")]),_vm._v(" "),_c('span',{staticClass:"mail-desc"},[_vm._v("Just see the my new admin!")]),_vm._v(" "),_c('span',{staticClass:"time"},[_vm._v("9:30 AM")])])]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('div',{staticClass:"btn btn-success btn-circle"},[_c('i',{staticClass:"ti-calendar"})]),_vm._v(" "),_c('div',{staticClass:"mail-contnet"},[_c('h5',[_vm._v("Event today")]),_vm._v(" "),_c('span',{staticClass:"mail-desc"},[_vm._v("Just a reminder that you have event")]),_vm._v(" "),_c('span',{staticClass:"time"},[_vm._v("9:10 AM")])])]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('div',{staticClass:"btn btn-info btn-circle"},[_c('i',{staticClass:"ti-settings"})]),_vm._v(" "),_c('div',{staticClass:"mail-contnet"},[_c('h5',[_vm._v("Settings")]),_vm._v(" "),_c('span',{staticClass:"mail-desc"},[_vm._v("You can customize this template as you want")]),_vm._v(" "),_c('span',{staticClass:"time"},[_vm._v("9:08 AM")])])]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('div',{staticClass:"btn btn-primary btn-circle"},[_c('i',{staticClass:"ti-user"})]),_vm._v(" "),_c('div',{staticClass:"mail-contnet"},[_c('h5',[_vm._v("Pavan kumar")]),_vm._v(" "),_c('span',{staticClass:"mail-desc"},[_vm._v("Just see the my admin!")]),_vm._v(" "),_c('span',{staticClass:"time"},[_vm._v("9:02 AM")])])])])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"nav-link text-center",attrs:{"href":"javascript:void(0);"}},[_c('strong',[_vm._v("Check all notifications")]),_vm._v(" "),_c('i',{staticClass:"fa fa-angle-right"})])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item dropdown hide"},[_c('a',{staticClass:"nav-link dropdown-toggle text-muted waves-effect waves-dark",attrs:{"href":"","id":"2","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('i',{staticClass:"mdi mdi-email"}),_vm._v(" "),_c('div',{staticClass:"notify"},[_c('span',{staticClass:"heartbit"}),_vm._v(" "),_c('span',{staticClass:"point"})])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu mailbox dropdown-menu-right scale-up",attrs:{"aria-labelledby":"2"}},[_c('ul',[_c('li',[_c('div',{staticClass:"drop-title"},[_vm._v("You have 4 new messages")])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"message-center"},[_c('a',{attrs:{"href":"#"}},[_c('div',{staticClass:"user-img"},[_c('img',{staticClass:"img-circle",attrs:{"src":__webpack_require__("mSs3"),"alt":"user"}}),_vm._v(" "),_c('span',{staticClass:"profile-status online pull-right"})]),_vm._v(" "),_c('div',{staticClass:"mail-contnet"},[_c('h5',[_vm._v("Pavan kumar")]),_vm._v(" "),_c('span',{staticClass:"mail-desc"},[_vm._v("Just see the my admin!")]),_vm._v(" "),_c('span',{staticClass:"time"},[_vm._v("9:30 AM")])])]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('div',{staticClass:"user-img"},[_c('img',{staticClass:"img-circle",attrs:{"src":__webpack_require__("Y7Jb"),"alt":"user"}}),_vm._v(" "),_c('span',{staticClass:"profile-status busy pull-right"})]),_vm._v(" "),_c('div',{staticClass:"mail-contnet"},[_c('h5',[_vm._v("Sonu Nigam")]),_vm._v(" "),_c('span',{staticClass:"mail-desc"},[_vm._v("I've sung a song! See you at")]),_vm._v(" "),_c('span',{staticClass:"time"},[_vm._v("9:10 AM")])])]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('div',{staticClass:"user-img"},[_c('img',{staticClass:"img-circle",attrs:{"src":__webpack_require__("2GvU"),"alt":"user"}}),_vm._v(" "),_c('span',{staticClass:"profile-status away pull-right"})]),_vm._v(" "),_c('div',{staticClass:"mail-contnet"},[_c('h5',[_vm._v("Arijit Sinh")]),_vm._v(" "),_c('span',{staticClass:"mail-desc"},[_vm._v("I am a singer!")]),_vm._v(" "),_c('span',{staticClass:"time"},[_vm._v("9:08 AM")])])]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('div',{staticClass:"user-img"},[_c('img',{staticClass:"img-circle",attrs:{"src":__webpack_require__("NFs6"),"alt":"user"}}),_vm._v(" "),_c('span',{staticClass:"profile-status offline pull-right"})]),_vm._v(" "),_c('div',{staticClass:"mail-contnet"},[_c('h5',[_vm._v("Pavan kumar")]),_vm._v(" "),_c('span',{staticClass:"mail-desc"},[_vm._v("Just see the my admin!")]),_vm._v(" "),_c('span',{staticClass:"time"},[_vm._v("9:02 AM")])])])])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"nav-link text-center",attrs:{"href":"javascript:void(0);"}},[_c('strong',[_vm._v("See all e-Mails")]),_vm._v(" "),_c('i',{staticClass:"fa fa-angle-right"})])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link dropdown-toggle text-muted waves-effect waves-dark",attrs:{"href":"","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('img',{staticClass:"profile-pic",attrs:{"src":__webpack_require__("mSs3"),"alt":"user"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-img"},[_c('img',{attrs:{"src":__webpack_require__("mSs3"),"alt":"user"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"ti-user"}),_vm._v(" My Profile")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-power-off"}),_vm._v(" Logout")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94f2eef2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("7mNm");
function injectStyle (ssrContext) {
  __webpack_require__("HJk8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94f2eef2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MwqM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NFs6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.94c9a5c.jpg";

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_ls__ = __webpack_require__("yXtV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_ls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__("ORbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters__ = __webpack_require__("OjAt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_moment__ = __webpack_require__("mjDs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_modal__ = __webpack_require__("rifk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_socket_io__ = __webpack_require__("hMcO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_socket_io___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_socket_io__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_events__ = __webpack_require__("EZrF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_progressbar__ = __webpack_require__("zYko");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_animate_number__ = __webpack_require__("J/MC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_animate_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_animate_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__App__ = __webpack_require__("M93x");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.















var socketio = __webpack_require__("DmT9"); // 'socket.io-client'

// global.jQuery = jQuery
// global.$ = jQuery

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

var options = {
  namespace: 'cellsmart.biz.masterAgent__'
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_ls___default.a, options);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue2_filters___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_moment___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_js_modal___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_events___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__webpack_require__("Z5Pw"));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_progressbar___default.a, {
  color: '#FFF907',
  failedColor: 'red'
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vue_animate_number___default.a);

var messages = __webpack_require__("Qvz8");

var i18n = new __WEBPACK_IMPORTED_MODULE_11_vue_i18n__["a" /* default */]({
  locale: 'en', // set locale
  fallbackLocale: 'en',
  messages: messages // set locale messages
});

// const serverAddress = "https://cellsmartapi.herokuapp.com/"
var serverAddress = "https://cellsmartapi.herokuapp.com";

var SocketInstance = socketio(serverAddress, { reconnection: true });
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_socket_io___default.a, SocketInstance);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('amountValue', function (value) {
  return parseFloat(value / 100).toFixed(2);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('state', function (value) {
  return value.replace(/US-/g, '');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.interceptors.push(function (request, next) {
  // console.log('start ', request)
  var orgID = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].ls.get('organization');
  request.headers.map['x-clientid'] = ['GXWCksIDm6LlmZfN'];
  request.headers.map['token'] = [__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].ls.get('token')];
  if (orgID) {
    request.headers.map['organizationid'] = [orgID.id];
  }

  next(function (response) {
    // console.log('saqib ', response)
    if (response.status === 401) {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ path: '/login' });
      if (response.body.token) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].ls.set('token', response.body.token);
      }
    }
  });
});

__WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (!to.meta.title) {
    to.meta.title = 'Master Agent';
  }
  document.title = 'Master Agent - ' + to.meta.title;
  next();
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.options.root = serverAddress + '/masterAgent/';
// Vue.http.options.root = 'http://stagingcspwebservices.us-east-1.elasticbeanstalk.com/'
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_7__store_store__["a" /* default */],
  i18n: i18n,
  router: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_13__App__["a" /* default */] }
}).$mount('#app');

/***/ }),

/***/ "OZvr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__("pOyM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f1a82a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__("cg4V");
function injectStyle (ssrContext) {
  __webpack_require__("S/eb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39f1a82a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f1a82a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "POok":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-light-icon.90af902.png";

/***/ }),

/***/ "Qvz8":
/***/ (function(module, exports, __webpack_require__) {

const messages = {
  en: __webpack_require__("xXim")
}

module.exports = messages


/***/ }),

/***/ "S/eb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T6AU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['isConnected'],
  data: function data() {
    return {
      userName: '',
      email: '',
      locationName: '',
      locationCode: this.$ls.get('locationCode')
    };
  },

  filters: {
    limitValue: function limitValue(value) {
      if (value) {
        return value.substring(0, 16) + '...';
      }
    }
  },
  sockets: {
    connect: function connect() {
      this.$socket.emit('join', { locationCode: this.locationCode });
      console.log('connected to socket');
    },
    global: function global(val) {
      console.log(val);
    }
  },
  methods: {
    setScrollBar: function setScrollBar() {
      $('.message-center').slimScroll({
        position: 'right',
        size: '5px',
        color: '#5C6A71'
      });
    },
    sendTest: function sendTest() {
      console.log('sent test');
      this.$socket.emit('testing', { test: 'test' });
    },
    checkDrawerStatus: function checkDrawerStatus() {
      var _this = this;

      var drawer = this.$ls.get('CashDrawerId');
      if (drawer === null) {
        this.$store.state.isShiftOpen = false;
      } else {
        this.$http.get('cashDrawer/' + drawer).then(function (drawerResult) {
          if (!drawerResult.data.available) {
            _this.$store.state.isShiftOpen = true;
          } else {
            _this.$store.state.isShiftOpen = false;
          }
        });
      }
    },
    closeShift: function closeShift() {
      this.$modal.show('close-shift');
    },
    openShift: function openShift() {
      this.$modal.show('open-shift');
    },
    logout: function logout() {
      this.$router.push({ name: 'login' });
      this.$ls.remove('CashDrawerId');
      this.$ls.remove('token');
    },
    getLogedinUser: function getLogedinUser() {
      var _this2 = this;

      return this.$http.get('employee/current').then(function (response) {
        _this2.userName = response.body.data.name;
        _this2.email = response.body.data.email;
      });
    },
    getLocationInfo: function getLocationInfo() {
      var _this3 = this;

      return this.$http.post('', { code: this.locationCode }).then(function (response) {
        _this3.$ls.set('CountryCode', response.body.data.Address.CountryCode);
        _this3.$ls.set('StateId', response.body.data.Address.StateId);
        _this3.locationName = response.body.data.name;
      });
    },
    sideBarToggler: function sideBarToggler() {
      if ($('body').hasClass('mini-sidebar')) {
        $('body').trigger('resize');
        $('.scroll-sidebar, .slimScrollDiv').css('overflow', 'hidden').parent().css('overflow', 'visible');
        $('body').removeClass('mini-sidebar');
        $('.navbar-brand span').show();
        // $('.sidebartoggler i').addClass('ti-menu')
      } else {
        $('body').trigger('resize');
        $('.scroll-sidebar, .slimScrollDiv').css('overflow-x', 'visible').parent().css('overflow', 'visible');
        $('body').addClass('mini-sidebar');
        $('.navbar-brand span').hide();
        // $('.sidebartoggler i').removeClass('ti-menu')
      }
    }
  },
  mounted: function mounted() {
    $('.fix-header .topbar').stick_in_parent({});
    this.setScrollBar();
    // this.getLogedinUser()
    // this.getLocationInfo()
    // this.checkDrawerStatus()
    //   this.orgName = this.$ls.get('organization').name
    //   this.user = this.$ls.get('user')
  }
});

/***/ }),

/***/ "Y7Jb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.29c23ad.jpg";

/***/ }),

/***/ "Y85j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Layout_Header__ = __webpack_require__("gd1P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Layout_Sidebar__ = __webpack_require__("OZvr");
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_0__components_Layout_Header__["a" /* default */],
    SideBar: __WEBPACK_IMPORTED_MODULE_1__components_Layout_Sidebar__["a" /* default */]
  },
  data: function data() {
    return {
      isConnected: this.$socket.connected
    };
  },

  sockets: {
    connect: function connect() {
      this.isConnected = this.$socket.connected;
      this.$socket.emit('join', { locationCode: this.$ls.get('locationCode'), deviceId: this.$ls.get('deviceId') });
      $.toast({
        heading: 'Server is back up',
        text: 'Connections has been established between client and server',
        position: 'top-right',
        showHideTransition: 'slide',
        icon: 'info'
      });
    },
    disconnect: function disconnect() {
      this.isConnected = this.$socket.connected;
    },
    message: function message(val) {
      console.log(val);
    }
  },
  mounted: function mounted() {
    // this.$lang.setLang('sp')
    // this.$i18n.locale = 'sp'
    var set = function set() {
      var width = window.innerWidth > 0 ? window.innerWidth : this.screen.width;
      var topOffset = 70;
      if (width < 1170) {
        $('body').addClass('mini-sidebar');
        $('.navbar-brand span').hide();
        $('.scroll-sidebar, .slimScrollDiv').css('overflow-x', 'visible').parent().css('overflow', 'visible');
        $('.sidebartoggler i').addClass('ti-menu');
      } else {
        $('body').removeClass('mini-sidebar');
        $('.navbar-brand span').show();
      }
      var height = (window.innerHeight > 0 ? window.innerHeight : this.screen.height) - 1;
      height = height - topOffset;
      if (height < 1) height = 1;
      if (height > topOffset) {
        $('.page-wrapper').css('min-height', height + 'px');
      }
    };
    $(window).ready(set);
    // ==============================================================
    // Sidebarmenu
    // ==============================================================
    $('#sidebarnav').metisMenu();
    // ==============================================================
    // Slimscrollbars
    // ==============================================================
    // $('.scroll-sidebar').slimScroll({
    //   position: 'left',
    //   size: '5px',
    //   height: '100%',
    //   color: '#dcdcdc'
    // })
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Layout_Layout__ = __webpack_require__("hPPz");





// - Terminal Const
var Register = function Register(resolve) {
  __webpack_require__.e/* require.ensure */(14).then((function () {
    resolve(__webpack_require__("kTq1"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Verify = function Verify(resolve) {
  __webpack_require__.e/* require.ensure */(8).then((function () {
    resolve(__webpack_require__("cExC"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Home = function Home(resolve) {
  __webpack_require__.e/* require.ensure */(9).then((function () {
    resolve(__webpack_require__("lO7g"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var InviteStore = function InviteStore(resolve) {
  __webpack_require__.e/* require.ensure */(3).then((function () {
    resolve(__webpack_require__("q3uZ"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var InviteUser = function InviteUser(resolve) {
  __webpack_require__.e/* require.ensure */(2).then((function () {
    resolve(__webpack_require__("eL5X"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Login = function Login(resolve) {
  __webpack_require__.e/* require.ensure */(15).then((function () {
    resolve(__webpack_require__("LoBU"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// const NewOrganization = resolve => {
//   require.ensure(['@/components/Organization/NewOrganization'], () => {
//     resolve(require('@/components/Organization/NewOrganization'))
//   })
// }

// const OrganizationNotFound = resolve => {
//   require.ensure(['@/components/Organization/OrganizationNotFound'], () => {
//     resolve(require('@/components/Organization/OrganizationNotFound'))
//   })
// }

var Employee = function Employee(resolve) {
  __webpack_require__.e/* require.ensure */(6).then((function () {
    resolve(__webpack_require__("+06C"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var ReportCenter = function ReportCenter(resolve) {
  __webpack_require__.e/* require.ensure */(12).then((function () {
    resolve(__webpack_require__("MzcM"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// const ActivationByEmployee = resolve => {
//   require.ensure(['../../../PublicComponents/src/components/Reports/ActivationByEmployee'], () => {
//     resolve(require('../../../PublicComponents/src/components/Reports/ActivationByEmployee'))
//   })
// }

var HyperLinkPointReport = function HyperLinkPointReport(resolve) {
  __webpack_require__.e/* require.ensure */(0).then((function () {
    resolve(__webpack_require__("GhH6"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var HyperLinkPointReportDetail = function HyperLinkPointReportDetail(resolve) {
  __webpack_require__.e/* require.ensure */(1).then((function () {
    resolve(__webpack_require__("Updy"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Error = function Error(resolve) {
  __webpack_require__.e/* require.ensure */(11).then((function () {
    resolve(__webpack_require__("U/fa"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Locations = function Locations(resolve) {
  __webpack_require__.e/* require.ensure */(5).then((function () {
    resolve(__webpack_require__("Q0dI"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var NewLocation = function NewLocation(resolve) {
  __webpack_require__.e/* require.ensure */(7).then((function () {
    resolve(__webpack_require__("iWQL"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Catalog = function Catalog(resolve) {
  __webpack_require__.e/* require.ensure */(4).then((function () {
    resolve(__webpack_require__("QaAo"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var NewCatalog = function NewCatalog(resolve) {
  __webpack_require__.e/* require.ensure */(10).then((function () {
    resolve(__webpack_require__("YSS9"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Setting = function Setting(resolve) {
  __webpack_require__.e/* require.ensure */(13).then((function () {
    resolve(__webpack_require__("6sH0"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{ path: '/',
    name: 'layout',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Layout_Layout__["a" /* default */],
    children: [{ path: '/', component: Home, name: 'home', meta: { title: 'Dashboard' } }, { path: '/error', component: Error, name: 'error', meta: { title: 'Error' } }, { path: '/setting', component: Setting, name: 'setting', meta: { title: 'Setting' } }, { path: '/invite/store', component: InviteStore, name: 'inviteStore', meta: { title: 'Invite Store' } }, { path: '/invite/user', component: InviteUser, name: 'inviteUser', meta: { title: 'Invite User' } }, { path: '/employee', component: Employee, name: 'employee', meta: { title: 'Employee' } }, { path: '/locations', component: Locations, name: 'locations', meta: { title: 'Locations' } }, { path: '/locations/new', component: NewLocation, name: 'NewLocations', meta: { title: 'Add Location' } }, { path: '/catalog', component: Catalog, name: 'catalog', meta: { title: 'Catalog' } }, { path: '/catalog/new', component: NewCatalog, name: 'newCatalog', meta: { title: 'New Product' } }, { path: '/reportCenter', component: ReportCenter, name: 'reportCenter', meta: { title: 'Report Center' } },
    // { path: '/reports/activationByEmployee', component: ActivationByEmployee, name: 'actiavtionByEmployee' },
    { path: '/reports/hyperlinkPointReport', component: HyperLinkPointReport, name: 'hyperlinkPointsReport', meta: { title: 'Hyperlink Point Report' } }, { path: '/reports/hyperlinkPointReport/:id', component: HyperLinkPointReportDetail, name: 'hyperlinkPointsReportDetail', meta: { title: 'Hyperlink Point Report' } }]
  }, { path: '/login', component: Login, name: 'login', meta: { title: 'Login' } }, { path: '/register', component: Register, name: 'register', meta: { title: 'Sign Up' } }, { path: '/verify', component: Verify, name: 'verify', meta: { title: 'Verifation' }
    // { path: '/organization/new', component: NewOrganization, name: 'newOrg', meta: {title: 'Create Organization'} },
    // { path: '/organization/notfound', component: OrganizationNotFound, name: 'orgNotFound', meta: {title: 'Select Organization'} }
  }],
  mode: 'history'
}));

/***/ }),

/***/ "cg4V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"left-sidebar"},[_c('div',{staticClass:"scroll-sidebar"},[_c('nav',{staticClass:"sidebar-nav"},[_c('ul',{attrs:{"id":"sidebarnav"}},[_c('li',{staticClass:"nav-small-cap"},[_vm._v(_vm._s(_vm.$t('sideBar.masterAgentMenu')))]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/"}},[_c('a',{staticClass:"waves-effect waves-dark",staticStyle:{"padding":"0"},attrs:{"href":"#"}},[_c('i',{staticClass:"ti ti-dashboard"}),_vm._v(" "),_c('span',{staticClass:"hide-menu"},[_vm._v(_vm._s(_vm.$t('sideBar.dashboard')))])])])],1),_vm._v(" "),_c('li',{staticClass:"nav-devider"}),_vm._v(" "),_c('li',[_c('a',{staticClass:"has-arrow waves-effect waves-dark",attrs:{"href":"#","aria-expanded":"false"}},[_c('i',{staticClass:"ti-location-pin"}),_c('span',{staticClass:"hide-menu"},[_vm._v(_vm._s(_vm.$t('sideBar.locations')))])]),_vm._v(" "),_c('ul',{staticClass:"collapse",attrs:{"aria-expanded":"false"}},[_c('li',[_c('router-link',{attrs:{"to":"/locations"}},[_vm._v(_vm._s(_vm.$t('sideBar.locations')))])],1)])]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/catalog"}},[_c('div',{staticClass:"waves-effect waves-dark"},[_c('i',{staticClass:"ti ti-mobile"}),_c('span',{staticClass:"hide-menu"},[_vm._v(_vm._s(_vm.$t('sideBar.catalog'))+" ")])])])],1),_vm._v(" "),_c('li',{staticClass:"nav-devider"}),_vm._v(" "),_c('li',[_c('a',{staticClass:"has-arrow waves-effect waves-dark",attrs:{"href":"#","aria-expanded":"false"}},[_c('i',{staticClass:"mdi mdi-settings"}),_c('span',{staticClass:"hide-menu"},[_vm._v(_vm._s(_vm.$t('sideBar.settings')))])]),_vm._v(" "),_c('ul',{staticClass:"collapse",attrs:{"aria-expanded":"false"}},[_c('li',[_c('router-link',{attrs:{"to":"/setting"}},[_vm._v(_vm._s(_vm.$t('sideBar.setting')))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/invite/user"}},[_vm._v(_vm._s(_vm.$t('sideBar.inviteUser')))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/invite/store"}},[_vm._v(_vm._s(_vm.$t('sideBar.inviteStore')))])],1)])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dAsA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fXYR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-light-text.7810e4d.png";

/***/ }),

/***/ "gd1P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("T6AU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c71b4d1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("HO3I");
function injectStyle (ssrContext) {
  __webpack_require__("MwqM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c71b4d1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c71b4d1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hPPz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__ = __webpack_require__("Y85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1692ee23_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__ = __webpack_require__("l+A8");
function injectStyle (ssrContext) {
  __webpack_require__("dAsA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1692ee23_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l+A8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main-wrapper"}},[_c('vue-progress-bar'),_vm._v(" "),_c('header-bar',{attrs:{"isConnected":_vm.isConnected}}),_vm._v(" "),_c('side-bar'),_vm._v(" "),_c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mSs3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.cb88fb0.jpg";

/***/ }),

/***/ "pOyM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    showBillPayment: function showBillPayment() {
      this.$modal.show('new-bill-payment', { callFrom: 'itself' });
    },
    setScrollBar: function setScrollBar() {
      $('.scroll-sidebar').slimScroll({
        position: 'right',
        size: '5px',
        height: '100%',
        color: '#5C6A71'
      });
    },
    testNot: function testNot() {
      console.log('test in here');
      // $.toast('Here you can put the text of the toast')
    }
  },
  mounted: function mounted() {
    this.setScrollBar();
  }
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "wtEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  isShiftOpen: false
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state
}));

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "xXim":
/***/ (function(module, exports) {

module.exports = {
  pageHeader: {
    addSimCard: 'Add Simcards',
    imeiNumber: 'IMEI Number',
    registerSale: 'Register Sale',
    newPayment: 'New Payment',
    prodcuts: 'Products',
    simcards: 'Simcards',
    closeShift: 'Close Shift',
    customer: 'Customer',
    newCustomer: 'New Customer',
    newPayee: 'New Payee',
    expense: 'Expense',
    location: 'Location',
    product: 'Product',
    inviteStore: 'Invite Store',
    inviteUser: 'Invite User',
    pointReport:'Point Report',
    category: 'Category',
    vendors: 'Vendors',
    payee: 'Payee',
    openShift: 'Open Shift',
    updateVendor: 'Update Vendor',
    cashDrawer: 'Cash Drawers',
    purchaseNumber: 'Purchase#',
    purchase: 'Purchase',
    activationSimCard: 'Activate Sim Card',
    simSwap: 'Sim Swap',
    changeNumber: 'Number Change',
    newVendor: 'New Vendor',
    masterAgent: 'Master Agent',
    catalog: 'Catalog',
    employee: 'Employee',
    newProduct: 'New Product',
    locations: 'Locations'
  },
  header: {
    notifications: 'Notifications',
    recoverPassword: 'Recover Password',
    invite: 'Invite',
    subscriberInformation: 'Subscriber Information',
    adding: 'Adding: {0}'
  },
  subTital: {
    simInformation: 'Sim Information',
    personalDetail: 'Personal Detail',
    onlyIcellutionsCardCanBeActivationOnThisPortal: 'Only iCellutions card can be actvation on this protal',
    pinSetup: 'Pin Setup',
    selectNumber: 'Selecte Number',
    finishActvation: 'Finish Actvation',
    finish: 'Finish'
  },
  navBar: {
    myProfile: 'My Profile',
    viewProfile: 'View Profile',
    closeShift: 'Close Shift',
    openShift: 'Open Shift',
    logout: 'Logout'
  },
  toastMessage: { //this.$t('toastMessage.heading.product'),
    heading: {
      invite: 'Invite Sent',
      inventory: 'Inventory',
      invoice: 'Invoice',
      vendor: 'Create Vendor',
      product: 'Product',
      updateVendor: 'Update Vendor'
    },
    text: {
      purchaseCancled: 'Purchase Was Created',
      invoiceIsCreated: 'Invoice is created',
      vendorCreated: 'Vendor Created',
      vendorUpdated: 'Vendor was updated!',
      productCreated: 'Product was created'
    }
  },
  messages: {
    title: {
      delete: 'Delete!',
      cancelled: 'Cancelled!',
      success: 'Success!',
      vendor: 'Vendor',
      areYouSure: 'Are you sure?',
      integration: 'Integration',
      addPayment: 'Add Payment',
      codeNotFound: 'Code Not Found'
    },
    text: {
      pleaseCheckTheCodeAndTryAgain: 'Please check the location code and try again.',
      enterValidAmount: 'Enter valid amount.',
      requestAccepted: 'Request was accepted!',
      enterYouEmailAddress: 'Enter your Email and instructions will be sent to you!',
      taxIsStillHere: 'Tax is still here :)',
      categoryIsStillHere: 'Category is still here :)',
      paymentStillOnDone: 'Payment still on done :)',
      paymentStillOnPending: 'Payment still on pending :)',
      youWantToDeleteThisTax: 'You want to delete this tax',
      youWantToContinueWithOutSelectingPlan: 'You want to continue without selecting plan!',
      youWantToDeleteThisCategory: 'You want to delete this category',
      youWantToMoveToPending: 'You want to move it to pending',
      youLikeToDeleteThisPurchase: 'You want to delete this purchase.',
      youWantToCancelThisSale: 'You want to cancel this sale.',
      youLikeToDeleteThisPayee: 'You like to delete this payee.',
      selectedRowIsDeleted: 'Selected row is deleted.',
      youWontBeAbleToRevertThis: "You won't be able to revert this!",
      unableToDeletePayee: 'Unable to delete payee :(',
      hasBeenDeleted: '{0} has been deleted.',
      youLikeToDeleteItem: 'You want to delete, {0}.',
      vendorNotSelected: 'Please select valid vendor before saving purchase',
      serialNumberAlreadyExist: 'Serial number already exist in this list',
      serialNumberAlreadyExistInThisOrder: 'Serial number already exist in this order',
      serialNumberYouHadPuchaseBefore: 'Serial number you had puchase before',
      youHaveDeleted: 'You have deleted',
      unableToDeletePurchase: 'Unable to delete purchase.'
    }
  },
  dataTable: {
    fromDate: 'From Date',
    toDate: 'To Date',
    runReport: 'Run Report',
    looksLikeThereIsNoData: "Looks like there's no data",
    trySelectingDifferentTimePeriod: 'Try selecting different time period.',
    action: 'Actoin',
    show: 'Show',
    entries: 'entries',
    showing: 'Showing',
    pageShowingDetail: 'Showing {0} to {1} of {2} entries',
    previous: 'Previous',
    next: 'Next',
    search: 'Search'
  },
  validations: {
    fieldIsRequired: 'Field is required',
    mustBeNumeric: 'Must be numeric.',
    mustBeMoreThen: 'Must be morethen',
    simNumberLimit: 'Sim number must have atleast {0} numbers.',
    productNameLimit: 'Product name must have atleast {0} letters.',
    pinNumberMustHaveAtLeast: 'Pin number must have at least {0} number.',
    pinNumberCantHaveMoreThen: "Pin number can't have more then {0} number.",
    pinNumberMustBeIdentical: 'Pin number must be identical.',
    youMustSelectOneNumber: 'You must select one number.',
    validEmailAddress: 'Enter valid email address',
    priceHaveToBeNumber: 'Accepts positive and negative decimal numbers.',
    mustBeSelectOne: 'Must be select one.'
  },
  labels: {
    walcome: 'Walcome',
    wantToJoinExisting: 'Want to join existing an Organization? Request the admin of that Organization to add you to their user list.',
    terminalcode: 'Terminal Code',
    source: 'Source',
    to: 'To',
    count: 'Count',
    points: 'Points',
    event: 'Event',
    saleCount: 'Sale Count',
    searchBusiness: 'Search Business',
    businessName: 'Business Name',
    averagePoint: 'Average Point',
    selectOne: 'Select One',
    wallet: 'Wallet',
    activation: 'Activation',
    walletBalance: 'Wallet Balance',
    wantToLogin: 'Want to login?',
    newSimNumber: 'New Sim Number',
    conformPinNumber: 'Conform Pin Number',
    pinNumber: 'Pin Number',
    subscribers: 'Subscribers',
    subscriber: 'Subscriber',
    optional: '(optional)',
    simNumber: 'Sim Number',
    refernceNumber: 'Reference Number',
    dontHaveAccount: "Don't have an account?",
    date: 'Date',
    subtotal: 'Sub - Total',
    unitCost: 'Unit Cost',
    purchaseID: 'Purchase ID',
    vendorName: 'Vendor Name',
    imeiNumber: 'IMEI Number',
    category: 'Category',
    defaultOpenCash: 'Default Open Cash',
    since: 'Since',
    customerSince: 'Customer Since',
    maxAmount: 'Max Amount',
    purchase: 'Purchase',
    amountDue: 'Amount Due',
    runningShift: 'Running Shift',
    availableDrawers: 'Available Drawers',
    payeeName: 'Payee Name',
    categoryName: 'Category Name',
    selectOne: 'Select One',
    selectPayee: 'Selecte Payee',
    totalCashCount: 'Total Cash Count',
    initialBalance: 'Initial Balance',
    reOrderPoint: 'Re-Order Point',
    reOrderAmount: 'Re-Order Amount',
    selectTax: 'Select Tax',
    selectedTax: 'Selected Tax',
    selectCategory: 'Selecte Category',
    refernceNumber: 'Refernce #',
    mustBeMoreThen: 'Must be morethen',
    readyToSale: 'Ready to sale',
    additional: 'Additional',
    purchaseCost: 'Purchase Cost',
    newPayee: 'New Payee',
    description: 'Description',
    brandName: 'Brand Name',
    enterPhoneNumberOrKeytag: 'Enter Phone Number or Keytag',
    selectCarrier: 'Select Carrier',
    pinNumber: 'Pin Number',
    selectProvider: 'Select Provider',
    note: 'Note',
    dueAmount: 'Due Amount',
    productImage: 'Product Image',
    autoApply: 'Auto Apply',
    value: 'Value',
    openShift: 'Open Shift',
    closeShift: 'Close Shift',
    closedShift: 'Closed Shift',
    searchProduct: 'Search Product',
    productName: 'Product Name',
    quantity: 'Quantity',
    amount: 'Amount',
    price: 'Price',
    discount: 'Discount',
    total: 'Total',
    customer: 'Customer',
    tax: 'Tax',
    name: 'Name',
    phone: 'Phone',
    spending: 'Spending',
    notTracked: 'Not Tracked',
    subTotal: 'Sub-total',
    createdAt: 'Created At',
    carrier: 'Carrier',
    provider: 'Provider',
    firstName: 'First Name',
    lastName: 'Last Name',
    phoneNumber: 'Phone Number',
    email: 'Email',
    emailAddress: 'Email Address',
    accountNumber: 'Account Number',
    website: 'Website',
    address: 'Address',
    signIn: 'Sign In',
    rememberMe: 'Remember me',
    city: 'City',
    forgotPassword: 'Forgot pwd?',
    state: 'State',
    zipCode: 'Zip Code',
    customerName: 'Customer Name',
    casherName: 'Casher Name',
    openAt: 'Open At',
    openBy: 'Open By',
    openingAmount: 'Opening Amount',
    closedAt: 'Closed At',
    closedBy: 'Closed By',
    leavingCash: 'Leaving Cash',
    totalSale: 'Total Sale',
    cashSale: 'Cash Sale',
    cashCount: 'Cash Count',
    masterCategory: 'Master Category',
    categories: 'Categories',
    fee: 'Fee',
    employee: 'Employee',
    confirmation: 'Confirmation',
    invoiceNumber: 'Invoice #',
    grandTotal: 'Grand Total',
    upcCode: 'UPC Code',
    skuCode: 'SKU Code',
    brand: 'Brand',
    stock: 'Stock'
  },
  tab: {
    pending: 'Pending',
    done: 'Done',
    cellSmart: 'CellSmart',
    onHold: 'On Hold',
    general: 'General',
    additional: 'Additional',
    tax: 'Tax',
    billPayment: 'Bill Payment',
    wallet: 'Wallet'
  },
  placeHolder: {
    addANoteToThisTransaction: 'Add a note to this transaction',
    searchFor: 'Search for...',
    addANoteToThisPurchase: 'Add a note to this purchase',
    emailAddress: 'Email Address'
  },
  sideBar: {
    simCards: 'Sim Cards',
    phoneNumber: 'Phone Number',
    inviteUser: 'Invite User',
    inviteStore: 'Invite Store',
    employee: 'Employee',
    masterAgent: 'Master Agent',
    masterAgentMenu: 'Master Agent - Menu',
    terminalMenu: 'Terminal - Menu',
    activeStore: 'Active Store',
    hyperLink: 'Hyperlink USA',
    catalog: 'Catalog',
    locations: 'Locations',
    icellutions: 'iCellutions',
    simSwap: 'Sim Swap',
    activationSim: 'Activate Sim',
    changeNumber: 'Change Number',
    mvnoMenu: 'MVNO - MENU',
    menu: 'menu',
    dashboard: 'Dashboard',
    register: 'Register',
    payment: 'Payment',
    paymentList: 'Payment List',
    newPayment: 'New Payment',
    history: 'History',
    manages: 'Manages',
    inventory: 'Inventory',
    reportCenter: 'Report Center',
    adminTools: 'Admin Tools',
    reviewInvoice: 'Review Invoice',
    reviewShift: 'Review Shift',
    product: 'Product',
    vendor: 'Vendor',
    customer: 'Customer',
    category: 'Category',
    payee: 'Payee',
    expense: 'Expense',
    purchase: 'Purchase',
    tax: 'Tax',
    expenseCategory: 'Expense Category',
    cashDrawers: 'Cash Drawers',
    settings: 'Settings',
    setting: 'Setting'
  },
  checkBox: {
    readyToSale: 'Ready to sale'
  },
  buttons: {
    revokeInvitation: 'Revoke Invitation',
    resendInvitation: 'Resend Invitaion',
    inviteStore: 'Invite Store',
    createNewOrg: 'Create New Organization',
    submitSimCard: 'Submit {0} Simcards',
    change: 'Change',
    newProduct: 'New Product',
    newSimcard: 'New Simcard',
    addToList: 'Add To List',
    openTerminal: 'Open Terminal',
    add: 'Add',
    newLocation: 'New Location',
    accept: 'Accept',
    newEmployee: 'New Employee',
    newCustomer: 'New Customer',
    newVendor: 'New Vendor',
    reject: 'Reject',
    newAgent: 'New Agent',
    yesMarkPending: 'Yes, Mark pending!',
    yesDoIt: 'Yes, do it!',
    open: 'Open',
    save: 'Save',
    reset: 'Reset',
    cancel: 'Cancel',
    close: 'Close',
    submit: 'Submit',
    pay: 'Pay',
    view: 'View',
    delete: 'Delete',
    edit: 'Edit',
    addToCart: 'Add to cart',
    newPayee: 'New Payee',
    newCategory: 'New Category',
    newPayment: 'New Payment',
    yesDeleteIt: 'Yes, delete it!',
    yesCancelIt: 'Yes! Cancel it',
    markDone: 'Mark it done',
    putOnHold: 'Put on hold',
    markPedning: 'Mark pending',
    addNew: 'Add New',
    login: 'Log In',
    signUp: 'Sign Up',
    generate: 'Generate',
    update: 'Update',
    no: 'No',
    print: 'Print',
    saveChange: 'Save Change',
    closeShift: 'Clsoe Shift'
  }
}


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.dedaef23dd2a348e3586.js